import React, { useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomSpinner from "../../../../../../components/customSpinner/CustomSpinner";
import useFilter from "../../../../../../hooks/useFilter";
import { HotelDataListI } from "../../../../../../redux/slices/enviromentSlice/EnviromentSlice.type";
import { ActiveHotelI } from "../../../mapview/Mapview";
import PropertyCard from "../../PropertyCard";

import styles from "./PropertyCardWrapper.module.scss";
import useScroll from "../../../../../../hooks/useScroll";
import { filterStateI } from "../../../../contexts/filterContext";
import UpdateUrlParams from "../../../../../../hooks/UpdateUrlParams";
import { useQueryParams } from "../../../../../../hooks/useQueryParams";

interface propsI {
  children: HotelDataListI[];
  filterState: filterStateI;
  isColumn?: boolean;
  setActiveHotel?: React.Dispatch<React.SetStateAction<ActiveHotelI>>;
  setIsMiniCardOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  dontDisplayNotAvailable?: boolean;
}

const PropertyCardWrapper = (props: propsI) => {
  // redux hooks
  const {
    children,
    filterState,
    isColumn,
    setActiveHotel,
    setIsMiniCardOpen,
    dontDisplayNotAvailable,
  } = props;

  const { t } = useTranslation();

  const { filteredArray } = useFilter(children, filterState);

  const { updateUrlParams } = UpdateUrlParams();

  const { scrollToAppTop } = useScroll();

  // const [pagination, setPagination] = useState(1);
  const { page: pagination } = useQueryParams();

  const [loading, setLoading] = useState(true);

  const paginationSplicer = (array: (HotelDataListI | undefined)[]) => {
    return array.slice((pagination - 1) * 10, (pagination - 1) * 10 + 10);
  };

  useEffect(() => {
    setLoading(false);
    // setPagination(1);
  }, [filteredArray]);

  const handleChangePage = (page: number) => {
    // setPagination(page);
    scrollToAppTop();
    updateUrlParams({
      page,
    });
  };

  return (
    <>
      {!loading ? (
        <div className={styles.mainContainer}>
          <div className={styles.container}>
            {filteredArray.length !== 0 ? (
              <>
                {dontDisplayNotAvailable
                  ? paginationSplicer(
                      filteredArray.filter((property) => property?.available)
                    ).map(
                      (property) =>
                        property && (
                          <PropertyCard
                            data={property}
                            filterState={filterState}
                            key={property.id}
                            isColumn={isColumn}
                            setActiveHotel={setActiveHotel}
                            setIsMiniCardOpen={setIsMiniCardOpen}
                            allowAllGuest={!!property.allowAllGuest}
                          />
                        )
                    )
                  : paginationSplicer(filteredArray).map(
                      (property) =>
                        property && (
                          <PropertyCard
                            data={property}
                            filterState={filterState}
                            key={property.id}
                            isColumn={isColumn}
                            setActiveHotel={setActiveHotel}
                            setIsMiniCardOpen={setIsMiniCardOpen}
                            allowAllGuest={!!property.allowAllGuest}
                          />
                        )
                    )}
              </>
            ) : (
              <p>{t("property.noPropertyFound")}</p>
            )}
            {
              <>
                {dontDisplayNotAvailable
                  ? filteredArray.filter((property) => property?.available)
                      .length > 10 && (
                      <Pagination
                        count={
                          Math.floor(
                            filteredArray.filter(
                              (property) => property?.available
                            ).length / 10
                          ) +
                          (filteredArray.filter(
                            (property) => property?.available
                          ).length % 10
                            ? 1
                            : 0)
                        }
                        defaultPage={1}
                        page={pagination}
                        onChange={(_, value) => handleChangePage(value)}
                      />
                    )
                  : filteredArray.length > 10 && (
                      <Pagination
                        count={
                          Math.floor(filteredArray.length / 10) +
                          (filteredArray.length % 10 ? 1 : 0)
                        }
                        defaultPage={1}
                        page={pagination}
                        onChange={(_, value) => handleChangePage(value)}
                      />
                    )}
              </>
            }
          </div>
        </div>
      ) : (
        <CustomSpinner />
      )}
    </>
  );
};

export default PropertyCardWrapper;
